import { render, staticRenderFns } from "./LoadingPropertys.vue?vue&type=template&id=45745118"
import script from "./LoadingPropertys.vue?vue&type=script&lang=js"
export * from "./LoadingPropertys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports